module.exports = __webpack_public_path__ + "img/quit.2a301cb6.svg";